import { VoraLogo } from "@/components/brand/VoraLogo";

export function AuthShell({ children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <VoraLogo variant="horizontal" tone="dark" />
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">{children}</div>
        <p className="mt-6 text-center text-xs text-slate-400">
          FELVORA Compliance · México
        </p>
      </div>
    </div>
  );
}
